<template>
  <v-dialog
    :value="dialog"
    @input="$emit('update:dialog', false)"
    :max-width="width"
    :content-class="contentClass"
    :fullscreen="fullscreen"
  >
    <v-card
      :style="actionsBottom ? 'display: flex; flex-direction: column' : ''"
    >
      <v-btn icon @click="$emit('update:dialog', false)" class="closeModalBtn">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-title class="headline">
        <slot name="headline">
          <h2>{{ title }}</h2>
        </slot>
      </v-card-title>
      <v-card-text>
        <slot name="body"></slot>
      </v-card-text>
      <v-card-actions style="margin-top: auto">
        <slot name="actions">
          <v-row align="center" justify="end" no-gutters>
            <v-btn @click="handlerModal" :disabled="!valid">
              <v-icon v-if="btnIcon" left>{{ btnIcon }}</v-icon> {{ btnText }}
            </v-btn>
          </v-row>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Modal",
  props: {
    actionsBottom: {
      type: Boolean,
      default: false,
    },
    dialog: {
      type: Boolean,
      default: false,
      required: true,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [String, Number],
      default: 800,
    },
    title: {
      type: String,
      default: "",
    },
    btnText: {
      type: String,
      default: "ОК",
    },
    btnIcon: {
      type: String,
      default: "",
    },
    contentClass: {
      type: String,
      default: "",
    },
    valid: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    handlerModal() {
      this.$emit("update:dialog", false);
      this.$emit("handler", true);
    },
  },
};
</script>
